module.exports = __webpack_public_path__ + "img/家用电器5.228c4db0.jpg";